import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, DollarSign, ShoppingCart, Users, TrendingUp } from "lucide-react";
import api, { formatPrice } from "../../lib/api";

function KPI({ icon: Icon, label, value }) {
  return (
    <div className="bg-white border border-linen p-6">
      <div className="flex items-center justify-between mb-4"><span className="eyebrow">{label}</span><Icon className="w-4 h-4 text-champagne-dark" /></div>
      <div className="font-serif text-3xl text-pitch">{value}</div>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  if (!stats) return <div className="text-stonemuted">Loading…</div>;

  return (
    <div>
      <h1 className="font-serif text-3xl text-pitch mb-8">Dashboard</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-6">
        <KPI icon={DollarSign} label="Gross Sales" value={formatPrice(stats.revenue)} />
        <KPI icon={TrendingUp} label="Archive Value" value={formatPrice(stats.archive_value)} />
        <KPI icon={Package} label="Live Archive" value={stats.available} />
        <KPI icon={ShoppingCart} label="Orders to Fulfil" value={stats.pending_orders} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8">
        <KPI icon={Package} label="Total Products" value={stats.total_products} />
        <KPI icon={Package} label="Sold" value={stats.sold} />
        <KPI icon={Users} label="Customers" value={stats.customers} />
      </div>

      <div className="bg-white border border-linen">
        <div className="px-6 py-4 border-b border-linen flex items-center justify-between">
          <h2 className="font-serif text-xl text-pitch">Recent Orders</h2>
          <Link to="/admin/orders" className="text-xs font-mono uppercase tracking-[0.15em] text-champagne-dark">View All</Link>
        </div>
        {stats.recent_orders?.length === 0 ? (
          <div className="px-6 py-12 text-center text-stonemuted">No orders yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-stonemuted border-b border-linen">
              <th className="px-6 py-3 font-mono text-xs uppercase tracking-wider">Order</th>
              <th className="px-6 py-3 font-mono text-xs uppercase tracking-wider">Customer</th>
              <th className="px-6 py-3 font-mono text-xs uppercase tracking-wider">Total</th>
              <th className="px-6 py-3 font-mono text-xs uppercase tracking-wider">Payment</th>
            </tr></thead>
            <tbody>
              {stats.recent_orders?.map((o) => (
                <tr key={o.id} className="border-b border-linen/60">
                  <td className="px-6 py-3 font-mono">{o.id}</td>
                  <td className="px-6 py-3">{o.customer?.name}</td>
                  <td className="px-6 py-3">{formatPrice(o.total)}</td>
                  <td className="px-6 py-3 uppercase text-xs font-mono">{o.payment_status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
